import reducer from "./reducer";
export { default as MyDesktop } from "./components/index";
export { default as myDesktopReducerName } from "./constants";
export default reducer;
